import { getCheck24Namespace } from 'utility/Provide/Namespace/getCheck24Namespace';

import {
    BackendInformationKeys,
    SearchFormDefaults,
} from 'types/legacy/backendInformation';
import { GlobalNamespace } from 'types/legacy/namespace';

const backendInformationFunc = (getCheck24Namespace() as GlobalNamespace)
    .components.backendInformationFunc;

const replaceValidatedParams = (validatedUrl: string, searchUrl: string) => {
    const validatedURL = new URL(validatedUrl);
    const replacedURL = new URL(searchUrl);
    const validatedQueryParams = getValidatedQueryParams(
        validatedURL,
        replacedURL
    );
    for (const key of validatedQueryParams) {
        replacedURL.searchParams.set(
            key,
            validatedURL.searchParams.get(key) ?? ''
        );
    }

    return decodeURIComponent(replacedURL.toString());
};

const getValidatedQueryParams = (validatedURL: URL, searchUrl: URL) => {
    const searchParamKeys = new Set(searchUrl.searchParams.keys());
    const validatedParamKeys = new Set(validatedURL.searchParams.keys());

    return [...searchParamKeys].filter((param) =>
        validatedParamKeys.has(param)
    );
};

export const validateAndReplaceUrl = (url: string) => {
    const searchFormUrl = backendInformationFunc.getData<SearchFormDefaults>(
        BackendInformationKeys.SearchFormDefaults
    ).searchFormUrl;
    const baseUrl = backendInformationFunc.getData(
        BackendInformationKeys.BaseUrl
    );

    if (!searchFormUrl || baseUrl === '') {
        return url;
    }

    const validatedURL = replaceValidatedParams(baseUrl + searchFormUrl, url);
    if (url === validatedURL) {
        return url;
    }

    window.history.replaceState(
        {
            target: 'hotelSearch',
            url: validatedURL,
        },
        '',
        validatedURL
    );

    return validatedURL;
};
